import { DatePicker } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { isValid } from 'date-fns';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useQuoteState } from 'shared/contexts';
import { useUpdateQuote } from 'shared/mutations';
import { Quote, QuoteDetailsForm } from 'shared/types';

interface ReminderDialogProps {
  quote: Quote;
}

export function ReminderDialog({ quote }: ReminderDialogProps) {
  const { reminderDialogOpen, toggleReminderDialogOpen } = useQuoteState();
  const methods = useForm<QuoteDetailsForm>({ defaultValues: quote });
  const [reminderDate, setReminderDate] = useState<Date | null>(
    quote.reminderDate ? new Date(quote.reminderDate) : new Date()
  );
  const updateMutation = useUpdateQuote(true);

  const { handleSubmit } = methods;

  const cancel = () => {
    toggleReminderDialogOpen();
  };

  const onChange = (date: Date | null) => {
    if (!isValid(date)) {
      date = null;
    }
    setReminderDate(date);
  };

  const onSubmit = async (data: Quote) => {
    const updatedQuote: Quote = {
      ...data,
      reminderDate: reminderDate?.toISOString(),
    };
    updateMutation.mutate(updatedQuote);
    toggleReminderDialogOpen();
  };

  return (
    <Dialog maxWidth={false} open={reminderDialogOpen}>
      <DialogTitle>Set Reminder Date</DialogTitle>
      <DialogContent>
        <Grid item>
          <FormProvider {...methods}>
            <form id='set-reminder-form' onSubmit={handleSubmit(onSubmit)}>
              <Grid item>
                <DatePicker
                  value={reminderDate}
                  onChange={onChange}
                  renderInput={params => (
                    <TextField
                      id={'reminderDate'}
                      {...params}
                      fullWidth
                      inputProps={{ ...params.inputProps, 'aria-label': 'Reminder Date' }}
                      placeholder='Reminder Date'
                    />
                  )}
                  minDate={new Date()}
                  maxDate={new Date(quote.expirationDate)}
                  mask='__-__-__'
                  inputFormat='MM-dd-yy'
                />
              </Grid>
            </form>
          </FormProvider>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={cancel}>
          cancel
        </Button>
        <Button variant='contained' type='submit' form='set-reminder-form'>
          save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
